import { useState } from "react";
import { useTranslation } from "react-i18next";
import AddFileModal from "./AddFileModal";
import DeleteFileModal from "./DeleteFileModal";
import { useSession } from "../../common/session/SessionContext";
import {
  ApsButton,
  ApsButtonAddLarge,
  ApsButtonGroup,
  ApsCard,
  ApsCardBody,
  ApsCardHeader,
  ApsFileButtonAddLarge,
  ApsUploadEntryContainer,
  ApsUploadEntryPage
} from 'UserExperience/portal-vnext';
import useResponseHandler from "../../common/responses/responseHandler";

export const supportedFileTypes = [
  "application/pdf",
  "image/tiff",
  "image/png",
  "image/gif",
  "image/jpeg",
  "image/jfif",
  "image/jpg",
  "application/vnd.ms-excel",
  "text/plain",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];

const DocumentPages = ({ document, headerTitleAlign, headerTitleSize, isMobile, onFinish, onCancel }) => {

  const { t } = useTranslation();
  const { addDocument } = useSession();
  const [selectedFiles, setSelectedFiles] = useState([...(document.files || [])]);
  const [isAddFileModalVisible, setIsAddFileModalVisible] = useState(false);
  const [isDeleteFileModalVisible, setIsDeleteFileModalVisible] = useState(false);
  const [fileToDelete, setFileToDelete] = useState(null);
  const headerTitle = t('documentPages.headerTitle');
  const headerSubtitle = isMobile ? '' : t('addDocumentTray.headerSubtitle');
  const pageIndexText = t('documentPages.pageIndex');
  const addButtonText = t('documentPages.addPageButton');
  const finishButtonText = isMobile ? t('addDocumentScreen.finishButton') : t('addDocumentTray.finishButton');
  const cancelButtonText = t('documentPages.cancelButton');
  const invalidFileTypeText = t('documentPages.invalidFileType')
  const { handleError } = useResponseHandler();


    
  const isValidFileType = (fileType) => {
    return supportedFileTypes.includes(fileType);
  };

  const fileSelected = file => {
    if(isValidFileType(file.type)) {
      setSelectedFiles(currentSelectedFiles => [...currentSelectedFiles, file]);
      closeAddFileModal();
    }
    else {
      var errorMessage = {data: invalidFileTypeText};
      handleError(errorMessage);
    }

  };

  const openDeleteFileModal = file => {
    setFileToDelete(file);
    setIsDeleteFileModalVisible(true);
  };

  const closeDeleteFileModal = () => {
    setIsDeleteFileModalVisible(false);
  }

  const deleteFile = () => {
    if (fileToDelete) {
      setSelectedFiles(currentSelectedFiles => currentSelectedFiles.filter(currentFile => currentFile !== fileToDelete));
      setFileToDelete(null);
    }
    closeDeleteFileModal();
  };

  const openAddFileModal = () => {
    setIsAddFileModalVisible(true);
  };

  const closeAddFileModal = () => {
    setIsAddFileModalVisible(false);
  };

  const finish = () => {
    document.files = selectedFiles;
    addDocument(document);
    onFinish();
  };


  return (
    <>

      <ApsCard>

        <ApsCardHeader
          headerTitle={headerTitle}
          headerSubtitle={headerSubtitle}
          headerTitleAlign={headerTitleAlign}
          headerTitleSize={headerTitleSize}
        />

        <ApsCardBody hasPadding={true}>
        
          <ApsUploadEntryContainer>

            {selectedFiles && selectedFiles.map((file, index) =>
            <ApsUploadEntryPage
              key={index}
              name={`${pageIndexText} ${(index + 1)}`}
              onDelete={() => openDeleteFileModal(file)}
            />
            )}
            <DeleteFileModal
              visible={isDeleteFileModalVisible}
              onOk={deleteFile}
              onCancel={closeDeleteFileModal}
            />


          </ApsUploadEntryContainer>

          {isMobile &&
          <>
            <ApsButtonAddLarge
              buttonLabel={addButtonText}
              onClick={openAddFileModal}
            />
            <AddFileModal
              visible={isAddFileModalVisible}
              onFileSelect={fileSelected}
              onCancel={closeAddFileModal}
            />
          </>
          }

          {!isMobile &&
          <ApsFileButtonAddLarge
            buttonLabel={addButtonText}
            selectMultiple="false"
            minSize="10"
            maxSize="5mb"
            onSelect={fileSelected}
          />}

        </ApsCardBody>

      </ApsCard>

      <ApsButtonGroup
        groupInset={true}
        groupType="separate"
      >

        {selectedFiles && selectedFiles.length > 0 &&
        <ApsButton
          buttonLabel={finishButtonText}
          buttonShape="pill"
          buttonType="primary"
          onClick={finish}
        />}

        <ApsButton
          buttonLabel={cancelButtonText}
          buttonShape="pill"
          buttonType="secondary"
          onClick={onCancel}
        />

      </ApsButtonGroup>

    </>
  );
};

export default DocumentPages;
